export default {
    SET_LOADING_STATE: "skills/SET_LOADING_STATE",
    SET_SKILLS_DATA: "skills/SET_SKILLS_DATA",
    SET_DIALOG_STATE: "skills/SET_DIALOG_STATE"
}
